export default __webpack_public_path__ + "static/media/Analyse-statistics.6a1cb24b.png";